import type { SmsFilters } from '@webapp/account/src/resources/smsing/filters';
import type { Recipient } from '@webapp/account/src/resources/smsing/recipient';
import type { Sms, SmsEditMode, SmsGroup, SmsParams, SmsStat } from '@webapp/account/src/resources/smsing/smsing';
import { RecipientType, SmsStatus, SmsType } from '@webapp/account/src/resources/smsing/smsing';

import type { States } from '../states';

import type { SmsingState } from './state';

export const smsing = ({ Smsing }: States): SmsingState => Smsing;

export const selectAllSmsGroups = (states: States): Array<SmsGroup> => {
    const m = smsing(states);

    return m.smsGroups || [];
};

export const selectVisibleSmsGroups = (states: States): Array<SmsGroup> => {
    const m = selectAllSmsGroups(states);

    return m.filter(({ hidden }) => !hidden);
};

export const selectAllSmsing = (states: States): Array<Sms> => {
    const m = smsing(states);

    return m.items.filter(({ status }) => status !== SmsStatus.DELETED);
};

export const selectSmsListFetch = (states: States): boolean => {
    const m = smsing(states);

    return m.fetch;
};

export const selectSmsingFilters = (states: States): SmsFilters => {
    const m = smsing(states);

    return m.filters;
};

export const selectSendDates = (states: States): Array<string> => {
    const m = smsing(states);

    return m.sendDates;
};

export const selectCurrentSms = (states: States): Sms => {
    const m = smsing(states);

    return m.item;
};

export const selectCurrentSmsId = (states: States): number => {
    const m = selectCurrentSms(states);

    return m.id;
};

export const selectCurrentSmsStat = (states: States): SmsStat => {
    const m = selectCurrentSms(states);

    return m.stat;
};

export const selectRecipients = (states: States): Array<Recipient> => {
    const m = selectCurrentSms(states);

    return m.recipients;
};

export const selectSmsParams = (states: States): SmsParams => {
    const m = selectCurrentSms(states);

    return m.params;
};

export const buttonColor = (states: States): string => {
    const p = selectSmsParams(states);

    return p.buttonColor;
};

export const buttonText = (states: States): string => {
    const p = selectSmsParams(states);

    return p.buttonText;
};

export const selectFullHtml = (states: States): string => {
    const p = selectCurrentSms(states);

    return p.template;
};

export const selectTemplate = (states: States): string => {
    const p = selectCurrentSms(states);

    return p.template;
};

export const selectExcludeDuplicate = (states: States): boolean => {
    const p = selectSmsParams(states);

    return p.excludeDuplicate;
};

export const selectduplicateInfo = (states: States): any => {
    const p = selectCurrentSms(states);

    return p?.duplicate;
};

export const selectExcludeDuplicatePeriod = (states: States): number => {
    const p = selectSmsParams(states);

    return p.excludeDuplicatePeriod;
};

export const selectExcludeDuplicateWho = (states: States): Array<string> => {
    const p = selectSmsParams(states);

    return p.excludeDuplicateWho;
};

export const selectEditMode = (states: States): SmsEditMode => {
    const p = selectSmsParams(states);

    return p.editMode;
};

export const selectSmsGroups = (states: States): Array<SmsGroup> => {
    const m = selectCurrentSms(states);

    return m.smsGroups;
};

export const selectHasRecipients = (states: States): boolean => {
    const g = selectSmsGroups(states);
    const r = selectRecipients(states);

    return g?.length + r?.length > 0;
};

export const selectFetchUpload = (states: States): boolean => {
    const m = smsing(states);

    return m.fileUpload;
};

export const selectRecipientType = (states: States): RecipientType => {
    const m = selectCurrentSms(states);

    return m.who;
};

export const selectCyr2Lat = (states: States): boolean => {
    const m = selectSmsParams(states);

    return m.cyr2Lat;
};

export const selectRecipientCount = (states: States): number => {
    const w = selectRecipientType(states);
    const s = selectCurrentSmsStat(states);

    switch (w) {
        case RecipientType.NO_REPLY:
            return s.notAnswered;
        case RecipientType.REPLY:
            return s.answered;
        case RecipientType.ALL:
            return s.all;
    }
};

export const selectCanScheduleById = (states: States): boolean => {
    const hasRecipients = selectHasRecipients(states);
    const { smsType } = selectCurrentSms(states);
    const count = selectRecipientCount(states);

    return hasRecipients || (smsType === SmsType.NOTIFY && count > 0);
};
